import React from 'react';
import { Button, Avatar, Icon } from '@socialchorus/shared-ui-components';
import { ExternalCard } from '../../../models/chatbot/types';

interface ExternalRefCardProps {
  card: ExternalCard;
  onClick?: () => void;
}

const ExternalRefCard: React.FC<ExternalRefCardProps> = ({ card, onClick }) => {
  if (card.action.type !== 'navigation') {
    return null;
  }

  const url = card.action.navigation.url;

  return (
    <Button
      variant="link"
      href={url}
      title={card.heading}
      className="ai-content__reference-card ai-content__reference-card--external"
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      asChild
    >
      <div className="ai-content__reference-card-content">
        <div className="ai-content__reference-card-body">
          <div
            className={`ai-content__reference-avatar${
              card.icon ? ' ai-content__reference-avatar--thumbnail' : ''
            }`}
          >
            {card.icon ? (
              <Avatar imgSrc={card.icon} size="medium" shape="square" alt="" />
            ) : (
              <Icon size={24}>language</Icon>
            )}
            {card.sourceIcon && (
              <div className="ai-content__reference-source-overlay">
                <img src={card.sourceIcon} alt="" />
              </div>
            )}
          </div>
          <div className="ai-content__reference-text">
            <h4 className="ai-content__reference-title">{card.heading}</h4>
            {card.subheading && (
              <p className="ai-content__reference-description">
                {card.subheading}
              </p>
            )}
          </div>
        </div>
      </div>
    </Button>
  );
};

export default ExternalRefCard;
